
import axios from 'axios';

import config from './config';
import { getAuthToken, removeAuthToken } from '../lib/localStorage'
import isLogin from '../lib/isLogin';

axios.defaults.baseURL = config.API_URL;

// Only set Authorization header if the token is actually valid (not expired)
// Avoids stale token persisting after expiry, which caused login page to appear stuck
const savedToken = getAuthToken();
if (savedToken && isLogin()) {
  axios.defaults.headers.common['Authorization'] = savedToken;
} else if (savedToken && !isLogin()) {
  // Token exists but is expired - clean it up immediately
  removeAuthToken();
}

export const setAuthorization = (token) => {
    axios.defaults.headers.common['Authorization'] = token;
}

export const removeAuthorization = () => {
    delete axios.defaults.headers.common["Authorization"];
}

export const handleResp = (respData, type = 'success') => {
    try {

        if (isLogin() && type == 'error' && respData && respData.response && respData.response.status == 401) {
            removeAuthToken()
            removeAuthorization()
            window.location.href = '/login'
            return true
        }
    } catch (err) {
        return false
    }
}

export default axios;